import React from 'react';
import { Navigate } from 'react-router-dom';

// Konten halaman Kontak telah digabungkan ke halaman Tentang
// URL /contact akan otomatis redirect ke /about#kontak
const Contact = () => {
  return <Navigate to="/about" replace />;
};

export default Contact;
